<template>
  <section class="bigScreen">
    <!-- <el-button class="reflash" @click="peckText(0)">语音播放</el-button> -->
    <p :class="'tittleP ' + tittleP">
      玖龙智通管理系统『{{
        comInfoObj.com_info && comInfoObj.com_info.name
      }}』成品业务大屏
    </p>
    <p :class="'titleTime ' + nowTimeNewClass">
      {{ nowTimeNew }}
    </p>
    <img class="tittlePng" :src="tittlePng" alt="" />
    <div class="mainDiv">
      <div class="leftDiv disi">
        <div class="leftDivHead">
          <p class="leftDivHeadTitle c-fff fs36">
            总装卸平台：{{ listWarehouseObj.total_parking }}个
          </p>
          <p class="stateText flexMM c-fff fs32">
            <span class="stateSizeS bodr2 bg-e6c841 disi mr10"></span>
            <span
              >作业中:
              <span class="c-e6c841">{{ listWarehouseObj.in_busy }}</span>
              个</span
            >
          </p>
          <p class="stateText flexMM c-fff fs32">
            <span class="stateSizeS bg-00cece disi mr10"></span>
            <span
              >空闲中:
              <span class="c-00cece">{{ listWarehouseObj.in_idle }}</span
              >个</span
            >
          </p>
        </div>
        <vue-seamless-scroll
          :data="listWarehouseObj.warehouse"
          :class-option="optionButtom1"
          ref="listWarehouseObjElement"
          class="factoryMainDiv"
        >
          <div
            class="factoryDiv"
            v-for="(item, index) in listWarehouseObj.warehouse"
            :key="index"
          >
            <p class="factoryDivTitle tac c-fff fs30">{{ item.name }}</p>
            <div class="positionDiv">
              <div
                class="positionState"
                v-for="(location, localtionIndex) in item.location"
                :key="localtionIndex"
              >
                <span
                  v-show="location.state == 0"
                  class="stateSizeB bg-00cece disi"
                ></span>
                <span
                  v-show="location.state == 0"
                  class="positionNum fs22 lineHide c-00cece"
                  >{{ location.name }}</span
                >
                <span
                  v-show="location.state == 1"
                  class="stateSizeB bg-e6c841 disi"
                ></span>
                <span
                  v-show="location.state == 1"
                  class="positionNum fs22 lineHide c-e6c841"
                  >{{ location.name }}</span
                >
              </div>
            </div>
          </div>
        </vue-seamless-scroll>
      </div>
      <div class="rightDiv disi">
        <div class="rightDivHead">
          <span class="fs38 c-00cece pr5">今日预约车次</span>
          <span class="fs42 c-fff pr10">{{
            listCarNumberObj.booking_car_number
          }}</span>
          <span class="lineColumn "></span>
          <span class="fs38 c-00cece pr5 pl10">完成率</span>
          <span class="fs42 c-fff pr10"> {{ completePrec }}% </span>
          <span class="lineColumn "></span>
          <span class="fs38 c-00cece pr5 pl10">未到厂车次:</span>
          <span class="fs42 c-fff pr10">{{
            listCarNumberObj.not_info_car_number
          }}</span>
          <span class="fs38 c-00cece pr5">正在排队:</span>
          <span class="fs42 c-fff pr10">{{
            listCarNumberObj.queuing_car_number
          }}</span>
          <span class="fs38 c-00cece pr5">正在叫号:</span>
          <span class="fs42 c-fff pr10">{{
            listCarNumberObj.call_car_number
          }}</span>
          <span class="fs38 c-00cece pr5">正在装车:</span>
          <span class="fs42 c-fff pr10">{{
            listCarNumberObj.loading_car_number
          }}</span>
          <span></span>
        </div>
        <div class="loadingDiv mainDivbr">
          <div class="loadingDivHead bg-001d4c" ref="loadingDivHead">
            <vue-seamless-scroll
              v-if="playObj.length > 0"
              :data="playObj"
              :class-option="optionLeft"
              ref="playObjElement"
              @ScrollEnd="playScrollEnd"
              class="w100"
            >
              <p
                class="fs36 c-fff"
                v-for="(item, index) in playObj"
                :key="index"
              >
                <img class="pr10 hornPng" :src="hornPng" />
                <span>请“</span>
                <span class="fs42 c-ffda3e">{{ item.info.license_plate }}</span>
                <span>”的师傅前往“</span>
                <span class="fs36 c-ffda3e">
                  {{ item.info.warehouse_name }}
                  &nbsp;&nbsp;
                  {{ item.info.parking_space_name }}
                </span>
                <span>”办理装车业务！</span>
              </p>
            </vue-seamless-scroll>
            <p v-else class="fs36 c-fff">
              <img class="pr10 hornPng" :src="hornPng" />
              <span>暂无车辆</span>
            </p>
          </div>

          <div class="dataHead fs27 tac c-078cc8">
            <span class="sp1">排队编号</span>
            <span class="sp2">车牌号</span>
            <span class="sp3">物流单位</span>
            <span class="sp4">车型</span>
            <span class="sp5">装车位置</span>
            <span class="sp6">进厂时间</span>
            <span class="sp7">排队状态</span>
          </div>

          <vue-seamless-scroll
            :data="listQueueCarObj.items"
            :class-option="optionButtom2"
            sroolType="1"
            ref="listQueueCarObjElement"
            class="dataDiv w100"
          >
            <div
              class="dataRow fs32 tac c-fff8"
              v-for="(item, index) in listQueueCarObj.items"
              :key="index"
            >
              <span class="sp1 c-fff8 lineHide">
                <template
                  v-if="
                    item.queue_code == undefined || item.queue_code.length == 0
                  "
                >
                  --
                </template>
                <template v-else>
                  {{ item.queue_code }}
                </template>
              </span>
              <span class="sp2 c-fff8 lineHide">
                <template
                  v-if="
                    item.license_plate == undefined ||
                      item.license_plate.length == 0
                  "
                >
                  --
                </template>
                <template v-else>
                  {{ item.license_plate }}
                </template>
              </span>
              <span class="sp3 c-fff8 lineHide">
                <template
                  v-if="
                    item.unit_short_name == undefined ||
                      item.unit_short_name.length == 0
                  "
                >
                  --
                </template>
                <template v-else>
                  {{ item.unit_short_name }}
                </template>
              </span>
              <span class="sp4 c-fff8 lineHide">
                {{ vehicleTypeText(item.vehicle_type) }}
              </span>
              <span class="sp5 c-fff8 lineHide">
                <template
                  v-if="
                    item.warehouse_name.length == 0 &&
                      item.parking_space_name.length == 0
                  "
                >
                  --
                </template>
                <template v-else>
                  {{ item.warehouse_name }}
                  {{ item.parking_space_name }}
                </template>
              </span>
              <span class="sp6 c-fff8 lineHide">
                <template
                  v-if="
                    item.queue_begin_time == undefined ||
                      item.queue_begin_time.length == 0
                  "
                >
                  --
                </template>
                <template v-else>
                  {{ formatTime(item.queue_begin_time) }}
                </template>
              </span>
              <span
                :class="'sp7 lineHide ' + queueStateTextColor(item.queue_state)"
              >
                {{ queueStateText(item.queue_state) }}
              </span>
            </div>
          </vue-seamless-scroll>
        </div>
        <div class="otherCarDiv">
          <div class="otherCarDivL mainDivbr">
            <div class="otherCarDivLHead bg-00579c bg-00579c-new">
              <span class="c-00bcd7 fs32 mr10">已发运车次:</span>
              <span class="c-fff fs38">{{ listLeaveCarObj.count }}</span>
            </div>
            <div class="dataHead fs27 tac c-078cc8 c-078cc8-new">
              <span class="osp33">车牌号</span>
              <span class="osp33">物流单位</span>
              <!-- <span class="osp3">产品线</span> -->
              <span class="osp33">离厂时间</span>
            </div>
            <vue-seamless-scroll
              :data="listLeaveCarObj.items"
              :class-option="optionButtom3"
              sroolType="1"
              ref="listLeaveCarObjElement"
              class="dataDivBottom w100"
            >
              <div
                class="dataRow fs32 tac c-fff"
                v-for="(item, index) in listLeaveCarObj.items"
                :key="index"
              >
                <span class="osp33 c-fff8 lineHide">
                  <template
                    v-if="
                      item.license_plate == undefined ||
                        item.license_plate.length == 0
                    "
                  >
                    --
                  </template>
                  <template v-else>
                    {{ item.license_plate }}
                  </template>
                </span>
                <span class="osp33 c-fff8 lineHide">
                  <template
                    v-if="
                      item.unit_short_name == undefined ||
                        item.unit_short_name.length == 0
                    "
                  >
                    --
                  </template>
                  <template v-else>
                    {{ item.unit_short_name }}
                  </template>
                </span>
                <!-- <span class="osp3 c-fff8 lineHide">
                  {{ businessNameText(item.business) }}
                </span> -->
                <span class="osp33 c-fff8 lineHide">
                  <template
                    v-if="
                      item.leave_factory_time == undefined ||
                        item.leave_factory_time.length == 0
                    "
                  >
                    --
                  </template>
                  <template v-else>
                    {{ formatTime(item.leave_factory_time) }}
                  </template>
                </span>
              </div>
            </vue-seamless-scroll>
          </div>
          <div class="otherCarDivR mainDivbr">
            <div class="otherCarDivLHead bg-00579c bg-00579c-new ">
              <span class="c-00bcd7 fs32 mr10">装车后滞留车辆:</span>
              <span class="c-fff fs38">{{ listStrandedCarObj.count }}</span>
            </div>
            <div class="dataHead fs27 tac c-078cc8 c-078cc8-new">
              <span class="osp33">车牌号</span>
              <span class="osp33">物流单位</span>
              <!-- <span class="osp3">产品线</span> -->
              <span class="osp33">滞留时间</span>
            </div>
            <vue-seamless-scroll
              :data="listStrandedCarObj.items"
              :class-option="optionButtom3"
              sroolType="1"
              ref="listStrandedCarObjElement"
              class="dataDivBottom w100"
            >
              <div
                class="dataRow fs32 tac c-fff"
                v-for="(item, index) in listStrandedCarObj.items"
                :key="index"
              >
                <span class="osp33 c-fff8 lineHide">
                  <template
                    v-if="
                      item.license_plate == undefined ||
                        item.license_plate.length == 0
                    "
                  >
                    --
                  </template>
                  <template v-else>
                    {{ item.license_plate }}
                  </template>
                </span>
                <span class="osp33 c-fff8 lineHide">
                  <template
                    v-if="
                      item.unit_short_name == undefined ||
                        item.unit_short_name.length == 0
                    "
                  >
                    --
                  </template>
                  <template v-else>
                    {{ item.unit_short_name }}
                  </template>
                </span>
                <!-- <span class="osp3 c-fff8 lineHide">
                  {{ businessNameText(item.business) }}
                </span> -->
                <span class="osp33 c-fff8 lineHide">
                  <template
                    v-if="
                      item.stranded_time == undefined ||
                        item.stranded_time.length == 0
                    "
                  >
                    --
                  </template>
                  <template v-else>
                    {{ minNumTotext(item.stranded_time) }}
                  </template>
                </span>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>
      </div>
    </div>
    <pagebutton></pagebutton>
  </section>
</template>

<script>
import socketListStoreMixin from "@/mixins/rh/socketListStoreMixin.js";
import socketListComputedMixin from "@/mixins/rh/socketListComputedMixin.js";
import socketConnetMixin from "@/mixins/rh/socketConnetMixin.js";
// import vueSeamlessScroll from "vue-seamless-scroll";
import vueSeamlessScroll from "@/components/vue-seamless-scroll-Plus/myClass.vue"; // vue-seamless-scroll修改版本
import pagebutton from "./pagebutton.vue"; //
import audioArr from "./vodata.js";
import { mapMutations } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      deviceId: "",
      socketConnetMixinRoom: "ROOM_LOUNGE", //socketConnetMixin 加入对应的房间
      socketConnetMixinUnGetToken: true,
      autoReloadPage: true,
      hornPng: require("./assets/img/horn.png"),
      tittlePng: require("./assets/img/tittle.png"),
      emptymp3: require("./assets/empty.mp3"),
      com_id: "",
      business_id: "",
      callingItems: [],
      queuingItems: [],
      missCallItems: [],
      listCarNumberObj: {
        booking_car_number: 0,
        not_info_car_number: 0,
        queuing_car_number: 0,
        call_car_number: 0,
        loading_car_number: 0
      }, //车辆统计
      listQueueCarObj: { items: [] }, //排队中车辆
      listQueueCarObjLoadingObj: {}, // 排队中滚动的数据标识
      listQueueCarObjItemsBefore: [], // 下一次渲染数据
      listWarehouseObj: {
        total_parking: 0,
        in_busy: 0,
        in_idle: 0,
        warehouse: []
      }, // 仓库位置
      listStrandedCarObj: {}, //滞留车辆
      listStrandedCarObjItems: [], //滚动部分数据
      listStrandedCarObjLoadingObj: {}, //发运车辆滚动的数据标识
      listLeaveCarObj: {}, //发运车辆
      listLeaveCarObjItems: [], //滚动部分数据
      listLeaveCarObjLoadingObj: {}, //发运车辆滚动的数据标识
      comInfoObj: {},
      AllPalyObjList: [],
      playObj: [],
      AudioPaly: false,
      audioPalyList: [],
      playScrollEndIndex: 0,
      leaveAndStrandlistInterval: null, // 5分钟定时刷新 已发运车次和装车后滞留车辆
      tempaudioArr: audioArr,
      playAudioing: false,
      stepUrl: "",
      stepArr: [],
      nowTimeNew: "",
      nowTimeNewClass: "",
      tittleP: ""
    };
  },
  components: { vueSeamlessScroll, pagebutton },
  mixins: [socketConnetMixin, socketListStoreMixin, socketListComputedMixin],
  async mounted() {
    /* eslint-disable no-undef */
    // apiready = () => {
    //   window.api.alert(JSON.stringify(window.api.deviceId));
    // };
    // 全屏显示
    // try {
    //   document.body.requestFullscreen();
    // } catch (error) {
    //   console.warn("全屏显示异常", error);
    // }
  },
  watch: {
    async isJoinRoomAndMonitorEven(val) {
      if (val) {
        console.log("清空数据");
        console.log("获取业务数据");
        this.listCarNumber();
        this.listQueueCar();
        this.listWarehouse();
        this.listStrandedCar();
        this.listLeaveCar();
      } else {
        console.log("socket断开");
      }
    },
    evenQueueList(val) {
      const evenQueue = JSON.parse(val);
      console.warn("socket数据来", evenQueue);
      this.changeAllObj(evenQueue);
    },
    callingItems() {
      this.setListQueueCarObjItems();
      // 高效性能设备，显示全部滚动数据
      // if (this.listQueueCarObj.items.length < 20) {
      //   this.setListQueueCarObjItems();
      // }
    },
    queuingItems() {
      this.setListQueueCarObjItems();
      // 高效性能设备，显示全部滚动数据
      // if (this.listQueueCarObj.items.length < 20) {
      //   this.setListQueueCarObjItems();
      // }
    },
    missCallItems() {
      this.setListQueueCarObjItems();
      // 高效性能设备，显示全部滚动数据
      // if (this.listQueueCarObj.items.length < 20) {
      //   this.setListQueueCarObjItems();
      // }
    },
    audioPalyList(val) {
      // console.log("开始播放", val);
      this.playAudioing = true;
      this.peckText();
      if (val.length == 0) {
        // 播放下一个
        this.playAudioing = false;
        this.AllPalyObjList.splice(0, 1);
      }
    },
    AllPalyObjList(val) {
      // console.log("播放队列数据变更", val);
      if (val.length == 0 || this.playAudioing) {
        // 设置队列工作中状态，如果socket断了，此刻可以重连
        this.setSocketBsStatu(false);
        return;
      }
      let data = val[0];
      // 滚动
      this.playObj = JSON.parse(JSON.stringify([data, data, data]));
      this.playScrollEndIndex = 0;
      if (this.$refs.playObjElement) {
        this.$refs.playObjElement.reset();
        this.$refs.playObjElement._startMove();
      }
      // 语音播放
      if (this.AudioPaly) {
        // 设置队列工作中状态，如果socket断了，暂时不重连
        this.setSocketBsStatu(true);
        this.audioPalyList = JSON.parse(
          JSON.stringify([data, data, data, data])
        );
        this.audioPalyList[0].more.calling_audio[0] = this.emptymp3;
      }
    }
  },
  computed: {
    optionLeft() {
      return {
        direction: 2,
        limitMoveNum: 3,
        step: this.stepArr[0] || 1.5,
        hoverStop: false
      };
    },
    optionButtom1() {
      let limitMoveNum = 1;
      this.listWarehouseObj.warehouse.forEach(item => {
        if (item.location.length < 3) {
          limitMoveNum++;
        }
      });
      limitMoveNum = 1;
      return {
        limitMoveNum: limitMoveNum,
        step: this.stepArr[1] || 0.6,
        hoverStop: false
      };
    },
    optionButtom2() {
      return {
        limitMoveNum: 6,
        step: this.stepArr[1] || 0.6,
        hoverStop: false
      };
    },
    optionButtom3() {
      return {
        limitMoveNum: 3,
        step: this.stepArr[1] || 0.6,
        hoverStop: false
      };
    },
    businessNameText() {
      return business => {
        if (!(business instanceof Array)) {
          return "";
        }
        let businessTextArr = [];
        business.forEach(item => {
          businessTextArr.push(item.name);
        });
        let businessText = "--";
        if (businessTextArr.length > 0) {
          businessText = businessTextArr.join("、");
          if (businessTextArr.length > 1) {
            businessText = businessText.slice(0, businessText.length - 1);
          }
        }
        return businessText;
      };
    },
    queueStateTextColor() {
      return state => {
        if (state == 1) {
          return "c-ffda3e";
        }
        if (state == 2) {
          return "c-f8375a";
        }
        if (state == 3) {
          return "c-1890ff";
        }
        return "";
      };
    },
    completePrec() {
      let prec = 0;
      if (
        Number(this.listCarNumberObj.delivery_car_number) > 0 &&
        Number(this.listCarNumberObj.booking_car_number) > 0
      ) {
        prec = Number(
          Number(
            (
              this.listCarNumberObj.delivery_car_number /
              this.listCarNumberObj.booking_car_number
            ).toFixed(2)
          ) * 100
        ).toFixed(0);
      }
      return prec;
    }
  },
  beforeRouteLeave(_to, _form, next) {
    window.clearInterval(this.leaveAndStrandlistInterval);
    next();
  },
  created() {
    // try {
    //   /* eslint-disable no-undef */
    //   this.deviceId = api && api.deviceId;
    // } catch (error) {
    //   console.warn("deviceId error", error);
    // }

    this.com_id = this.$route.query.com_id;

    this.business_id = this.$route.query.business_id || "";
    this.AudioPaly = this.$route.query.audio_paly == 1 ? true : false;
    this.stepUrl = this.$route.query.step;
    if (this.stepUrl && this.stepUrl.indexOf("_")) {
      this.stepArr = this.stepUrl.split("_");
    }
    this.getComInfo();
    // this.listCarNumber();
    // this.listQueueCar();
    // this.listWarehouse();
    // this.listStrandedCar();
    // this.listLeaveCar();
    // 5分钟定时刷新 已发运车次和装车后滞留车辆
    // this.leaveAndStrandlistInterval = window.setInterval(() => {
    //   // this.listStrandedCar();
    //   // this.listLeaveCar();
    // }, 2 * 60 * 1000);

    // 语音播放测试
    // window.setInterval(() => {
    //   console.log("开始播放");
    //   this.peckTextTest();
    // }, 15 * 1000);

    let that = this;
    window.setInterval(getNowTimeNew, 1 * 1000);
    function getNowTimeNew() {
      that.nowTimeNew = moment().format("YYYY-MM-DD HH:mm:ss");
      if (that.nowTimeNewClass === "") {
        that.nowTimeNewClass = "op099";
      } else {
        that.nowTimeNewClass = "";
      }
    }
    getNowTimeNew();
  },
  methods: {
    ...mapMutations(["setSocketBsStatu"]),
    playScrollEnd() {
      this.playScrollEndIndex++;
      if (this.playScrollEndIndex == 2) {
        // 暂时屏蔽
        this.$refs.playObjElement._stopMove();
      }
      // console.log("playScrollEnd");
    },
    // 装车后滞留车辆处理
    playScrollEndlistStranded() {
      this.setListStrandedObjItems();
    },
    setListStrandedObjItems(_s, _n) {
      let listLeaveObjLoadingObj = this.listStrandedCarObjLoadingObj;
      // 10分钟重新加载时，0开始循环
      if (_s != undefined && _n != undefined) {
        listLeaveObjLoadingObj = { start: _s, end: _n };
      }
      let list = this.listStrandedCarObj.items || [];
      let tmpList = [];
      // 小于20条
      if (list.length < 20) {
        // 更新数据
        // if (list.length != this.listStrandedCarObjItems.length) {
        list.forEach(item => {
          tmpList.push(item);
        });
        // }
        listLeaveObjLoadingObj = { start: 0, end: list.length };
      } else {
        // 大于20条
        let start = listLeaveObjLoadingObj.end || 0;
        let end = start + 20;
        // 本次加载够长
        if (end < list.length) {
          list.forEach((item, index) => {
            if (start <= index && index < end) {
              tmpList.push(item);
            }
          });
          listLeaveObjLoadingObj = { start: start, end: end };
        } else {
          list.forEach((item, index) => {
            if (start <= index && index < end) {
              tmpList.push(item);
            }
          });
          // 重新加入隊列前面部分
          start = 0;
          end = end - list.length;
          list.forEach((item, index) => {
            if (start <= index && index < end) {
              tmpList.push(item);
            }
          });
          listLeaveObjLoadingObj = { start: start, end: end };
        }
        // 取上一个前面4个
        let before6 = this.listStrandedCarObjItems.slice(
          this.listStrandedCarObjItems.length - 4,
          this.listStrandedCarObjItems.length
        );
        tmpList = before6.concat(tmpList);
        // console.log(indexArry);
      }
      this.listStrandedCarObjLoadingObj = listLeaveObjLoadingObj;
      // 更新数据
      if (tmpList.length != 0) {
        this.listStrandedCarObjItems = tmpList;
        this.$nextTick(() => {
          this.$refs.listStrandedCarObjElement.reset();
        });
      }
    },
    // 已发运车次车辆处理
    playScrollEndlistLeave() {
      this.setlistLeaveObjItems();
    },
    setlistLeaveObjItems(_s, _n) {
      let listLeaveObjLoadingObj = this.listLeaveObjLoadingObj;
      // 10分钟重新加载时，0开始循环
      if (_s != undefined && _n != undefined) {
        listLeaveObjLoadingObj = { start: _s, end: _n };
      }
      let list = this.listLeaveCarObj.items || [];
      let tmpList = [];
      // 小于20条
      if (list.length < 20) {
        // 更新数据
        if (list.length != this.listLeaveCarObjItems.length) {
          list.forEach(item => {
            tmpList.push(item);
          });
        }
        listLeaveObjLoadingObj = { start: 0, end: list.length };
      } else {
        // 大于20条
        let start = listLeaveObjLoadingObj.end || 0;
        let end = start + 20;
        // 本次加载够长
        if (end < list.length) {
          list.forEach((item, index) => {
            if (start <= index && index < end) {
              tmpList.push(item);
            }
          });
          listLeaveObjLoadingObj = { start: start, end: end };
        } else {
          list.forEach((item, index) => {
            if (start <= index && index < end) {
              tmpList.push(item);
            }
          });
          // 重新加入隊列前面部分
          start = 0;
          end = end - list.length;
          list.forEach((item, index) => {
            if (start <= index && index < end) {
              tmpList.push(item);
            }
          });
          listLeaveObjLoadingObj = { start: start, end: end };
        }
        // 取上一个前面4个
        let before6 = this.listLeaveCarObjItems.slice(
          this.listLeaveCarObjItems.length - 4,
          this.listLeaveCarObjItems.length
        );
        tmpList = before6.concat(tmpList);
      }
      this.listLeaveObjLoadingObj = listLeaveObjLoadingObj;
      // 更新数据
      if (tmpList.length != 0) {
        this.listLeaveCarObjItems = tmpList;
        this.$nextTick(() => {
          this.$refs.listLeaveCarObjElement.reset();
        });
      }
    },
    // 排队中车辆处理
    playScrollEndlistQueue() {
      console.log("playScrollEndlistQueue");
      // 高效性能设备，显示全部滚动数据
      // this.setListQueueCarObjItems();
    },
    setListQueueCarObjItemsBefore() {
      console.log("listQueueCarObjLoadingObj");
      let list = this.callingItems
        .concat(this.queuingItems)
        .concat(this.missCallItems);
      let tmpList = [];
      let listLeaveObjLoadingObj = this.listQueueCarObjLoadingObj;
      // 小于20条
      if (list.length < 20) {
        // 更新数据
        list.forEach(item => {
          tmpList.push(item);
        });
        listLeaveObjLoadingObj = { start: 0, end: list.length };
      } else {
        // 大于20条
        let start = listLeaveObjLoadingObj.end || 0;
        let end = start + 20;
        // 本次加载够长
        if (end < list.length) {
          list.forEach((item, index) => {
            if (start <= index && index < end) {
              tmpList.push(item);
            }
          });
          listLeaveObjLoadingObj = { start: start, end: end };
        } else {
          list.forEach((item, index) => {
            if (start <= index && index < end) {
              tmpList.push(item);
            }
          });
          // 重新加入隊列前面部分
          start = 0;
          end = end - list.length;
          list.forEach((item, index) => {
            if (start <= index && index < end) {
              tmpList.push(item);
            }
          });
          listLeaveObjLoadingObj = { start: start, end: end };
        }
        // 取上一个前面6个
        let before6 = this.listQueueCarObj.items.slice(
          this.listQueueCarObj.items.length - 7,
          this.listQueueCarObj.items.length
        );
        tmpList = before6.concat(tmpList);
      }
      this.listQueueCarObjLoadingObj = listLeaveObjLoadingObj;
      return tmpList;
    },
    setListQueueCarObjItems() {
      let list = this.callingItems
        .concat(this.queuingItems)
        .concat(this.missCallItems);
      this.listQueueCarObj.items = list;

      // 高效性能设备，显示全部滚动数据
      // let tmpList = [];
      // if (this.listQueueCarObjItemsBefore.length == 0) {
      //   tmpList = this.setListQueueCarObjItemsBefore();
      // } else {
      //   tmpList = this.listQueueCarObjItemsBefore;
      // }
      // // 渲染数据
      // this.listQueueCarObj.items = tmpList;
      // this.$nextTick(() => {
      //   this.$refs.listQueueCarObjElement.reset();
      // });
      // // 当数据大于20是，提前准备好下一次滚动的数据
      // let list = this.callingItems
      //   .concat(this.queuingItems)
      //   .concat(this.missCallItems);
      // if (list.length > 20) {
      //   this.listQueueCarObjItemsBefore = this.setListQueueCarObjItemsBefore();
      // }
    },
    // 移除播放队列
    delAllPalyObjList(_data) {
      let _list = this.AllPalyObjList;
      let index = -1;
      for (let i = 0; i < _list.length; i++) {
        let element = _list[i];
        if (
          element.queue_id == _data.queue_id &&
          Number(element.response_time) < Number(_data.response_time)
        ) {
          index = i;
          break;
        }
      }
      if (index != -1) {
        _list.splice(index, 1);
      }
    },
    // 处理socket数据
    changeAllObj({ actions, data }) {
      actions.forEach(element => {
        console.log(element, data);
        // 产品线过滤
        console.log(
          "激活产品线id:" + this.business_id,
          "变更数据id：" + data.business_id
        );
        console.log("操作数据");
        // 刷新车辆汇总数
        if (element.queue == "ACTION_REFRESH_NUMBER") {
          this.listCarNumber();
        }
        // 刷新趋势
        // if (element.queue == "ACTION_REFRESH_TREND") {

        // }
        // 更新装车位
        if (
          element.queue == "ACTION_OCCUPY_WAREHOUSE" ||
          element.queue == "ACTION_RELEASE_WAREHOUSE" ||
          element.queue == "ACTION_REFRESH_NUMBER"
        ) {
          this.listWarehouse();
        }
        // 产品线屏幕时,只处理当前产品线的数据
        if (
          this.business_id.length > 0 &&
          data.business_id != this.business_id
        ) {
          return;
        }
        // 语音队列
        if (element.queue == "VOICE") {
          // 放入播放队列
          if (element.action == "ACTION_PLAY_VOICE") {
            this.AllPalyObjList.push(data);
          }
          if (element.action == "ACTION_STOP_VOICE") {
            this.delAllPalyObjList(data);
          }
        }
        // 叫号中-正在叫号
        if (element.queue == "QUEUE_CALLING") {
          let tmpCallingItems = JSON.parse(JSON.stringify(this.callingItems));
          this.callingItems = this.reSetListBySocket(
            element.action,
            data,
            tmpCallingItems
          );
        }
        // 排队中
        if (element.queue == "QUEUE_QUEUE") {
          let tmpqueuingItems = JSON.parse(JSON.stringify(this.queuingItems));
          this.queuingItems = this.reSetListBySocket(
            element.action,
            data,
            tmpqueuingItems
          );
        }
        // 叫号中-已过号
        if (element.queue == "QUEUE_PASS_CALL") {
          let tmpmissCallItems = JSON.parse(JSON.stringify(this.missCallItems));
          this.missCallItems = this.reSetListBySocket(
            element.action,
            data,
            tmpmissCallItems
          );
        }
      });
    },
    // 车辆统计
    listCarNumber() {
      this.$common
        .http({
          url: "/api/queue/summary/list_car_number",
          data: {
            com_id: this.com_id,
            business_id: this.business_id
          },
          noLoading: true
        })
        .then(res => {
          this.listCarNumberObj = res.data.data;
          // console.warn(res);
        });
    },
    // 排队中车辆
    listQueueCar() {
      this.$common
        .http({
          url: "/api/queue/summary/list_queue_car",
          data: {
            com_id: this.com_id,
            business_id: this.business_id
          },
          noLoading: true
        })
        .then(res => {
          // this.listQueueCarObj = res.data.data;
          let miss_call_items = res.data.data.miss_call_items;
          let queuing_items = res.data.data.queuing_items;
          let calling_items = res.data.data.calling_items;
          let response_time = res.data.data.response_time;
          miss_call_items.forEach(item => {
            item.response_time = response_time;
            item.id = item.queue_id;
          });
          queuing_items.forEach(item => {
            item.response_time = response_time;
            item.id = item.queue_id;
          });
          calling_items.forEach(item => {
            item.response_time = response_time;
            item.id = item.queue_id;
          });
          this.missCallItems = miss_call_items;
          this.queuingItems = queuing_items;
          this.callingItems = calling_items;
          // this.missCallItems = [];
          // this.queuingItems = [];
          // this.callingItems = [];
          // 设置滚动数据
          this.setListQueueCarObjItems();
          // console.log(
          //   "排队数组",
          //   this.callingItems
          //     .concat(this.queuingItems)
          //     .concat(this.missCallItems)
          // );
          // this.listQueueCarObj.items = res.data.data.calling_items;
          // console.log("排队数组", this.listQueueCarObj.items);
          //
        });
    },
    // 仓库位置
    listWarehouse() {
      this.$common
        .http({
          url: "/api/queue/summary/list_warehouse",
          data: {
            com_id: this.com_id,
            business_id: this.business_id
          },
          noLoading: true
        })
        .then(res => {
          let listWarehouseObj = res.data.data;
          let warehouse = [];
          listWarehouseObj.warehouse.forEach(element => {
            if (element.location && element.location.length > 0) {
              warehouse.push(element);
            }
          });
          listWarehouseObj.warehouse = warehouse;
          this.listWarehouseObj = listWarehouseObj;
        });
    },
    // 滞留车辆
    listStrandedCar() {
      this.$common
        .http({
          url: "/api/queue/summary/list_stranded_car",
          data: {
            com_id: this.com_id,
            business_id: this.business_id
          },
          noLoading: true
        })
        .then(res => {
          this.listStrandedCarObj = res.data.data;
          this.setListStrandedObjItems(0, 20);

          let listlength = this.listStrandedCarObj.items.length;
          let nextLoad = 60;
          if (listlength > 35) {
            nextLoad = parseInt(listlength * 1.72);
          }
          setTimeout(() => {
            this.listStrandedCar();
            this.listCarNumber();
          }, nextLoad * 1000);
        });
    },
    // 发运车辆
    listLeaveCar() {
      this.$common
        .http({
          url: "/api/queue/summary/list_leave_car",
          data: {
            com_id: this.com_id,
            business_id: this.business_id
          },
          noLoading: true
        })
        .then(res => {
          this.listLeaveCarObj = res.data.data;
          this.setlistLeaveObjItems(0, 20);

          let listlength = this.listLeaveCarObj.items.length;
          let nextLoad = 60;
          if (listlength > 35) {
            nextLoad = parseInt(listlength * 1.72);
          }
          setTimeout(() => {
            this.listLeaveCar();
            this.listCarNumber();
          }, nextLoad * 1000);
        });
    },
    getComInfo() {
      this.$common
        .http({
          url: "/api/queue/summary/com_info",
          data: {
            com_id: this.com_id,
            business_id: this.business_id
          },
          noLoading: true
        })
        .then(res => {
          this.comInfoObj = res.data.data;
          setTimeout(() => {
            this.tittleP = "op099";
          }, 3000);
        });
    },
    reflash() {
      location.reload();
    },
    // 语音播报
    peckText(index = 0) {
      if (this.audioPalyList[0] == undefined) {
        return;
      }
      let df = document.createDocumentFragment();
      let audio_arr = this.audioPalyList[0].more.calling_audio;
      // 过滤后端没数据的情况
      if (
        this.audioPalyList[0].more &&
        this.audioPalyList[0].more.calling_audio &&
        audio_arr[index] != undefined
      ) {
        // let bs64 = "data:audio/wav;base64," + audio_arr[index];
        let bs64 = audio_arr[index];
        let sndAudio = new Audio(bs64);
        sndAudio.src = bs64;
        df.appendChild(sndAudio);
        sndAudio.addEventListener("ended", () => {
          df.removeChild(sndAudio);
          setTimeout(() => {
            this.peckText(index + 1);
          }, 500);
        });
        // sndAudio.currentTime = 0.1;
        sndAudio.play();
      } else {
        if (this.audioPalyList.length > 0) {
          setTimeout(() => {
            this.audioPalyList.splice(0, 1);
          }, 3500);
        }
      }
    },
    // 语音播报
    peckTextTest(index = 0) {
      let df = document.createDocumentFragment();
      let audio_arr = this.tempaudioArr;
      console.log(audio_arr[index]);
      let bs64 = "data:audio/wav;base64," + audio_arr[index];
      let sndAudio = new Audio(bs64);
      sndAudio.src = bs64;
      df.appendChild(sndAudio);
      sndAudio.addEventListener("ended", () => {
        df.removeChild(sndAudio);
        this.peckTextTest(index + 1);
      });
      sndAudio.currentTime = 0.1;
      sndAudio.play();
    }
  }
};
</script>
<style lang="less" scoped>
@leftWidth: 380px;
@leftDivHeadpl: 40px;
.bigScreen {
  height: 100%;
  width: 100%;
  background: #00305f;
  overflow: hidden;
  .op099 {
    opacity: 0.99999;
  }
  .bg-00cece {
    background-color: #00cece;
  }
  .bg-e6c841 {
    background-color: #e6c841;
  }
  .bg-00579c {
    background-color: #00579c;
  }
  .bg-00579c-new {
    background-color: #1b4a99 !important;
  }
  .bg-001d4c {
    background-color: #001d4c;
  }
  .c-00cece {
    color: #00cece;
  }
  .c-e6c841 {
    color: #e6c841;
  }
  .c-00cece {
    color: #00cece;
  }
  .c-ffda3e {
    color: #ffda3e;
  }
  .c-078cc8 {
    color: #078cc8;
  }
  .c-078cc8-new {
    color: #078cc8 !important;
  }
  .c-00bcd7 {
    color: #00bcd7;
  }
  .c-f8375a {
    color: #f8375a;
  }
  .c-1890ff {
    color: #1890ff;
  }
  .c-fff {
    color: #fff;
  }
  .c-fff8 {
    color: #ccd5df;
  }
  p {
    margin: 0;
  }
  .mr10 {
    margin-right: 10px;
  }
  .stateSizeS {
    width: 36px;
    height: 36px;
  }
  .stateSizeB {
    width: 52px;
    height: 52px;
  }
  .bodr2 {
    border-radius: 2px;
  }
  .flexMM {
    display: flex;
    align-items: center;
  }
  .flexCRM {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .fs60 {
    font-size: 60px;
  }
  .fs56 {
    font-size: 56px;
  }
  .fs48 {
    font-size: 48px;
  }
  .fs42 {
    font-size: 42px;
  }
  .fs40 {
    font-size: 40px;
  }
  .fs38 {
    font-size: 38px;
  }
  .fs36 {
    font-size: 36px;
  }
  .fs32 {
    font-size: 32px;
  }
  .fs30 {
    font-size: 30px;
  }
  .fs29 {
    font-size: 29px;
  }
  .fs28 {
    font-size: 28px;
  }
  .fs27 {
    font-size: 27px;
  }
  .fs26 {
    font-size: 26px;
  }
  .fs24 {
    font-size: 24px;
  }
  .fs22 {
    font-size: 22px;
  }
  .pr5 {
    padding-right: 5px;
  }
  .pr20 {
    padding-right: 20px;
  }
  .pl20 {
    padding-left: 20px;
  }
  .pr10 {
    padding-right: 10px;
  }
  .pl10 {
    padding-left: 10px;
  }
  .tac {
    text-align: center;
  }
  .w100 {
    width: 100%;
  }
  .tittleP {
    font-size: 42px;
    text-align: center;
    background-image: -webkit-linear-gradient(top, #24d7fc, #24d7fc, #ffffff);
    background-clip: text;
    -webkit-text-fill-color: transparent;
    position: absolute;
    width: 100%;
    top: -7px;
    line-height: 84px;
  }
  .titleTime {
    position: absolute;
    font-size: 28px;
    text-align: center;
    background-image: -webkit-linear-gradient(top, #24d7fc, #24d7fc, #ffffff);
    background-clip: text;
    -webkit-text-fill-color: transparent;
    position: absolute;
    top: -10px;
    right: 2px;
    line-height: 84px;
  }
  .tittlePng {
    height: 170px;
    width: 100%;
  }
  .disi {
    display: inline-block;
  }
  .mainDiv {
    display: flex;
    height: calc(100% - 148px);
    position: relative;
    top: -82px;
  }
  .leftDiv {
    width: @leftWidth;
    position: relative;
  }
  .rightDiv {
    width: calc(100% - @leftWidth);
    height: 100%;
    position: relative;
  }
  .leftDivHead {
    padding-left: @leftDivHeadpl;
  }
  .leftDivHeadTitle {
    padding-bottom: 25px;
  }
  .stateText {
    height: 35px;
    padding-bottom: 25px;
  }
  .positionDiv {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    align-content: flex-start;
    > div {
      width: 33.3%;
    }
  }
  .positionState {
    flex: 0 0 33%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-bottom: 20px;
    span {
      letter-spacing: -1px;
    }
  }
  .factoryMainDiv {
    height: calc(100% - 142px);
    overflow: hidden;
    width: 100%;
  }
  .factoryDiv {
    padding-bottom: 15px;
  }
  .factoryDivTitle {
    padding-bottom: 20px;
  }
  .positionNum {
    padding-top: 5px;
    width: 100%;
    text-align: center;
    display: inline-block;
  }
  .rightDivHead {
    padding-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 45px;
    line-height: 45px;
  }
  .lineColumn {
    height: 100%;
    width: 2px;
    background-image: linear-gradient(
      180deg,
      #00305f 0%,
      #00d0df 47%,
      #00305f 100%
    );
  }
  .mainDivbr {
    border: 2px solid #078cc8;
    border-radius: 2px 2px 0 0;
  }
  .loadingDiv {
    margin-top: 15px;
    width: calc(100% - 5px);
    height: 60%;
    // overflow: hidden;
  }

  .loadingDivHead {
    height: 79px;
    line-height: 79px;
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    // transform: translate(-25%, 0px);
    // transition: all 2s ease-in 2s;
    // animation: 10s rowLeft linear infinite normal;
    // -webkit-animation: 10s rowLeft ease-in infinite normal;
    // animation: 5s rowLeft linear infinite normal;

    // width: 300%;
    // display: flex;
    // animation-name: rowLeft;
    // animation-duration: 35s;
    // animation-timing-function: linear;
    // animation-iteration-count: infinite;
    // animation-direction: normal;
    > div {
      width: 100%;
      overflow: hidden;
    }
    p {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 1533px; // css3
      // width: 100%;
    }
  }
  .dataDiv {
    height: calc(100% - 146px);
    overflow: hidden;
  }
  .dataDivBottom {
    height: calc(100% - 129px);
    overflow: hidden;
  }
  .dataHead,
  .dataRow {
    display: flex;
    justify-content: space-between;
    line-height: 65px;
    span {
      letter-spacing: -2px;
    }
    .sp1 {
      width: 160px;
    }
    .sp2 {
      width: 150px;
    }
    .sp3 {
      width: 270px;
    }
    .sp4 {
      width: 100px;
    }
    .sp5 {
      width: 465px;
    }
    .sp6 {
      width: 225px;
    }
    .sp7 {
      width: 135px;
    }
    .osp1 {
      width: 25%;
    }
    .osp2 {
      width: 25%;
    }
    .osp3 {
      width: 25%;
    }
    .osp4 {
      width: 25%;
    }
    .osp33 {
      width: 33%;
    }
  }
  .otherCarDiv {
    display: flex;
    justify-content: space-between;
    width: calc(100% - 1px);
    margin-top: calc(15px);
    height: 36%;
  }
  .otherCarDivR {
    width: calc(50% - 10px);
    box-sizing: border-box;
  }
  .otherCarDivL {
    width: calc(50% - 10px);
    box-sizing: border-box;
  }
  .otherCarDivLHead {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 64px;
    line-height: 64px;
  }
  .lineHide {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    // text-align: left !important;
  }
  @keyframes rowLeft {
    0% {
      transform: translate3d(0, 0, 0);
    }
    50% {
      transform: translate3d(-33.3%, 0, 0);
    }
    100% {
      transform: translate3d(-66.6%, 0, 0);
    }
  }
}
</style>
<style lang="less">
.reflash {
  position: absolute;
  left: 0;
  top: 0;
  cursor: pointer;
  z-index: 10;
}
</style>
